/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1LocationCountriesIdMutationRequest,
  PutApiV1LocationCountriesIdMutationResponse,
  PutApiV1LocationCountriesIdPathParams,
  PutApiV1LocationCountriesId400,
  PutApiV1LocationCountriesId401,
  PutApiV1LocationCountriesId404,
  PutApiV1LocationCountriesId409,
  PutApiV1LocationCountriesId500,
} from "../../types/locationCountryController/PutApiV1LocationCountriesId.ts";

function getPutApiV1LocationCountriesIdUrl(
  id: PutApiV1LocationCountriesIdPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/location/countries/${id}` as const,
  };
  return res;
}

/**
 * @description Atualiza a sigla, o nome e o status de um país, além da tradução no idioma corrente. A sigla e o nome devem permanecer únicos. **(Requer Authorization para autenticação)**
 * @summary Atualizar país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:id}
 */
export async function putApiV1LocationCountriesId(
  id: PutApiV1LocationCountriesIdPathParams["id"],
  data?: PutApiV1LocationCountriesIdMutationRequest,
  config: Partial<RequestConfig<PutApiV1LocationCountriesIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1LocationCountriesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationCountriesId400
      | PutApiV1LocationCountriesId401
      | PutApiV1LocationCountriesId404
      | PutApiV1LocationCountriesId409
      | PutApiV1LocationCountriesId500
    >,
    PutApiV1LocationCountriesIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1LocationCountriesIdUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
